import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { UserService } from 'src/app/services/user/user.service';
import { EditTimeType, User } from 'src/models';

@Injectable({
  providedIn: 'root',
})
export class ApprovalsPlanService {
  constructor(private readonly userService: UserService) {}

  hasRegularUserNeedingApproval(users: User[]): boolean {
    return (users ?? []).some(
      user => user.role === 'user' && user.canEditTime === 'needApproval',
    );
  }

  async loadUsersWithSettings(): Promise<User[]> {
    return lastValueFrom(
      this.userService.users({ detail: 'settings' }).all().accumulated,
    );
  }

  /**
   * Manual time approvals are unavailable on Basic. Reset regular users
   * still set to "Approval needed" back to the default "Yes".
   */
  async resetNeedApprovalUsersOnBasicPlan(): Promise<string[]> {
    const users = await this.loadUsersWithSettings();
    const toReset = (users ?? []).filter(
      (user: User) => user.role === 'user' && user.canEditTime === 'needApproval',
    );

    await Promise.all(
      toReset.map(user =>
        lastValueFrom(this.userService.editProperties(user.id, { canEditTime: 'yes' })),
      ),
    );

    return toReset.map(user => user.id);
  }

  resolveCanEditTimeForDisplay(canEditTime: EditTimeType | undefined, isBasicPlan: boolean): EditTimeType {
    if (isBasicPlan && canEditTime === 'needApproval') {
      return 'yes';
    }
    return canEditTime ?? 'yes';
  }
}
